export default function rate_types(state = null, action) {
    switch (action.type) {
        case 'RATE_TYPES/SET': return action.rate_types;
        case 'RATE_TYPES/CLEAR': return null;
        default: return state;
    }
}
